import React from 'react';
import { useSelector } from 'react-redux';
import { PropertyDataType } from '@debbie/common/dist/properties';
import { CopyToClipboard } from '..';
import { Entity } from '@debbie/common/dist';
const PropertyTypeInfo = (props) => {
    const lang = useSelector((s) => s.lang);
    const { property } = props;
    let mention;
    switch (property.type) {
        case PropertyDataType.file:
            mention = `{{{ properties.${property.handle} }}}`;
            break;
        case PropertyDataType.checkbox:
            mention = `{{#if properties.${property.handle} }} On {{else}} Off {{/if}}`;
            break;
        default:
            mention = `{{ properties.${property.handle} }}`;
    }
    return (React.createElement("div", null,
        property.ref === Entity.Case && (React.createElement(React.Fragment, null,
            React.createElement("p", null,
                lang.properties.infoGuideMentions,
                ": "),
            React.createElement("p", { style: { textAlign: 'center' } },
                React.createElement("b", null,
                    React.createElement(CopyToClipboard, { text: mention }, mention))))),
        React.createElement("p", null,
            lang.properties.infoGuideImport,
            ":"),
        React.createElement("p", { style: { textAlign: 'center' } },
            React.createElement("b", null,
                React.createElement(CopyToClipboard, { text: property.handle }, property.handle)),
            ' ',
            lang.properties.or,
            ' ',
            React.createElement("b", null,
                React.createElement(CopyToClipboard, { text: property.label }, property.label)))));
};
export default PropertyTypeInfo;
//# sourceMappingURL=PropertyTypeInfo.js.map